import { render, staticRenderFns } from "./AiTaggingTourContainer.vue?vue&type=template&id=44f11e68"
import script from "./AiTaggingTourContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./AiTaggingTourContainer.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports